// reducers
import { FETCH_DATA_REQUEST, FETCH_DATA_SUCCESS, FETCH_DATA_FAILURE,GET_DATA_CUSTOMER,SET_DATA_DISCONNETION,GET_DATA_PENDING_CONNECTION_DETAILS,GET_DATA_CUSTOMER_DETAILS,SET_DATA_DISCONNETION_REMARK,GET_DATA_EVENT,CLEAR_ALL_DATA,GET_DATA_DISCONNETION_RULES,GET_DATA_DISCONNETION_RULES_RESET } from './action';

const initialState = {
    loading: false,
    data: [],
    customerData:{},
    discationRes:{},
    customerTableData:{},
    pandingConnectionDetails:{},
    discationRemark:{},
    disconnectionRulesDetails:{},
    eventData:{},
    error: ''
};

 const connectionReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DATA_REQUEST:
      return { ...state, loading: true };
    case FETCH_DATA_SUCCESS:
      return { loading: false, data: action.payload, error: '' };
    case FETCH_DATA_FAILURE:
      return { loading: false, data: [], error: action.error };
    case GET_DATA_CUSTOMER:
      return  { ...state, customerData:action.payload , loading: true }; 
    case GET_DATA_CUSTOMER_DETAILS:
      return  { ...state, customerTableData:action.payload , loading: true };  
    case SET_DATA_DISCONNETION:
      return  { ...state, discationRes:action.payload , loading: true };
    case SET_DATA_DISCONNETION_REMARK:
      return   { ...state, discationRemark:action.payload , loading: true };
    case GET_DATA_EVENT:
        return   { ...state, eventData:action.payload , loading: true };
    case GET_DATA_DISCONNETION_RULES_RESET:
          return   { ...state, disconnectionRulesDetails:[] , loading: true };
    case GET_DATA_DISCONNETION_RULES:
          return   { ...state, disconnectionRulesDetails:action.payload , loading: true };
    case CLEAR_ALL_DATA:
      return {...state, customerData:undefined,customerTableData:undefined,discationRemark:undefined}
    case GET_DATA_PENDING_CONNECTION_DETAILS:
          return  { ...state, pandingConnectionDetails:action.payload , loading: true };
    default:
      return state;
  }
};

export default connectionReducer;